import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// CRO: the proof bar addresses Trust and Authority objections
// Placed immediately after the hero to build confidence before features

const stats = [
    { value: '10B+', label: 'Tokens Burned in Research' },
    { value: '★ 5.0', label: 'Average Contractor Rating' },
    { value: '0', label: 'Data Breaches. Ever.' },
    { value: 'Diamond', label: 'HubSpot Partner Level' },
    { value: '#1', label: 'Zuper & Sumo Partner' },
];

const ProofBar = () => {
    const barRef = useRef(null);

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.from('.proof-item', {
                y: 20,
                opacity: 0,
                duration: 0.8,
                stagger: 0.1,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: barRef.current,
                    start: 'top 90%',
                }
            });
        }, barRef);
        return () => ctx.revert();
    }, []);

    return (
        <div ref={barRef} className="bg-[#0A0A14] border-b border-[#7B61FF]/10 py-6 px-6 md:px-16 overflow-x-auto">
            <div className="max-w-7xl mx-auto flex items-center justify-between gap-8 min-w-max md:min-w-0">
                {stats.map((stat, i) => (
                    <div key={i} className="proof-item flex flex-col items-center text-center shrink-0">
                        <span className="font-drama text-[#7B61FF] text-2xl md:text-3xl leading-tight">{stat.value}</span>
                        <span className="font-data text-[#F0EFF4]/30 text-[10px] uppercase tracking-widest mt-1">{stat.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProofBar;
